export default "https://cdn-static.gokick.com/assets/a6d011c942efc1c6cd2854aca00adc3db9e08265/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";